<template>
  <div class="messagecenterBangzhuIndex">
     <XR-head titleText="帮助中心" :rightShow="false" ref="headObj"></XR-head>

        <mu-list v-for="(categoryEntity,index) in categoryList" :key="categoryEntity.Id">
          <mu-list-item class="head" :title="categoryEntity.CategoryName">
            <router-link :to="'/helperList?id='+categoryEntity.Id+'&categoryName='+categoryEntity.CategoryName+'&icon='+getCategoryIcon(index)" v-if="categoryEntity.ArticleList &&categoryEntity.Rows>3" slot="right">              
              <mu-icon value=":fa fa-detail" color="grey600"/>
            </router-link>
            <mu-avatar :src="'/static/messageUsercenter/'+getCategoryIcon(index)" slot="leftAvatar"/>
          </mu-list-item>
           <mu-list-item class="problem" :title="articleEntity.ArticleTitle" v-if="categoryEntity.ArticleList" v-for="articleEntity in categoryEntity.ArticleList" :key="articleEntity.Id"
            :to="'/helperDetail?categoryName='+categoryEntity.CategoryName+'&id='+articleEntity.Id"
           >           
          </mu-list-item>
        </mu-list>

    <XR-toast  ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
export default {
  data(){
    return{
      categoryList:[]
    }
  },
  mounted(){
    this.getHelperCategoryList()
  },
  methods:{
    
    getHelperCategoryList(){
      var ths = this;   
      ths.$post(
        "/Shop/ArticleServer/GetHelperCatetgoryList",{rows:3, clientType:2}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false   
          ths.categoryList = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    },
    getCategoryIcon(index){
      if(index % 4 == 0){
        return '5.png';
      }
      else if(index % 4 == 1){
        return '6.png';
      }
      else if(index % 4 == 2){
        return '7.png';
      }
      else if(index % 4 == 3){
        return '8.png';
      }
    }
  }
}
</script>
<style>
  body.messagecenterBangzhuIndex{
    background: #eee;
  }
  .messagecenterBangzhuIndex .mu-list{
    background: #fff;
    padding: 0;
    margin-top: 15px;
  }
  .messagecenterBangzhuIndex .mu-list .head .mu-item-left .mu-avatar{
    width: 25px;
    height: 25px;
  }
  .messagecenterBangzhuIndex .mu-list .head .mu-item.show-left{
    padding-left: 50px;
    border-bottom: 1px solid #f5f5f5;
  }
  .messagecenterBangzhuIndex .mu-list .head .mu-item-content .mu-item-title{
    font-weight: bold;
    font-size: 16px;
  }
  .messagecenterBangzhuIndex .mu-list .problem .mu-item.show-left{
    padding-left: 0;
  }
  .messagecenterBangzhuIndex .mu-list .problem .mu-item-content .mu-item-title{
    font-size: 14px;
    color: #999;
  }
  .messagecenterBangzhuIndex .mu-list .problem .mu-item{
    min-height: 25px;
    padding: 8px 16px;
  }
  .messagecenterBangzhuIndex .mu-list .problem:last-child .mu-item{padding-bottom: 16px; }
  .messagecenterBangzhuIndex .mu-list .problem:nth-child(2) .mu-item{padding-top: 16px; }
</style>



// WEBPACK FOOTER //
// src/pages/helperCenter.vue